import './libraries';
import './mhelli.css';
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

// import { clarity } from 'react-microsoft-clarity';
import React from 'react';
import ReactDom from 'react-dom';
import {syncHistoryWithStore} from 'react-router-redux';
import {browserHistory} from 'react-router';
import {Provider} from 'react-redux';
import {AppContainer} from 'react-hot-loader';

import configureStore from './configureStore';
import {Application} from './containers/Application';
import { ServerDate, ServerDateSetup } from './containers/ServerDate'; 

require("react-hot-loader/patch");

const store = configureStore({
    drawer: {elementId: 'drawer'}
});

const history = syncHistoryWithStore(browserHistory, store, {
    selectLocationState (state) {
        return state.get('routing').toJS();
    }
}); 
 
ServerDateSetup(); 

document.addEventListener('click', function (e) {
    var metas = document.getElementsByTagName('meta');
    for (var i = 0; i < metas.length; i++) {
        if (metas[i].name == 'viewport')
            metas[i].content = 'width=device-width, initial-scale=1.0'
    }
    // console.log("meta changed");
});

export const render = () => {
    // if(window.location.hostname !== "localhost"){
    //     clarity.init('nyd7enaayh');
    // }
    ReactDom.render(
        <AppContainer>
            <Provider store={store}>
                <Application history={history}/>
            </Provider>
        </AppContainer>,
        document.getElementById('application-container'),
    );
};
render();

// serviceWorkerRegistration.register();
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then(regs => {
    regs.forEach(reg => reg.unregister());
  });
}